import * as React from "react";

export const IconFilePlus = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_37345_26303)">
        <path
          d="M11.6663 1.66602L4.99967 1.66602C4.08301 1.66602 3.34134 2.41602 3.34134 3.33268L3.33301 16.666C3.33301 17.5827 4.07467 18.3327 4.99134 18.3327L14.9997 18.3327C15.9163 18.3327 16.6663 17.5827 16.6663 16.666V6.66602L11.6663 1.66602ZM13.333 13.3327H10.833L10.833 15.8327H9.16634L9.16634 13.3327L6.66634 13.3327V11.666L9.16634 11.666L9.16634 9.16602H10.833L10.833 11.666H13.333V13.3327ZM10.833 7.49935V2.91602L15.4163 7.49935L10.833 7.49935Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_37345_26303">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
